import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  closeTagLabel: {
    id: 'jutro-components.widgets.Tag.close',
    defaultMessage: 'Close'
  }
});